<template>
  <main :class="['page', checkin == null && errcode == 807 ? 'page--error' : '']" role="main">
    <!-- 拿不到签到信息的时候展示原因 -->
    <section v-if="checkin == null && errcode > 0" aria-live="polite">
      <article class="error-box" v-if="errcode == 805">
        <img class="error-icon"
          src="https://cdn-xcxcustom.weiyoubot.cn/20210615/67599ce2a04eb8d67679b8376806f3dc.png" />
        <p class="error-title">该活动存在争议内容</p>
        <p class="error-text">请耐心等待有争议内容协商解决，有问题，请联系活动发起人</p>
      </article>
      <article class="error-box" v-if="errcode == 806">
        <img class="error-icon"
          src="https://cdn-xcxcustom.weiyoubot.cn/20210615/8ff8b64c0ef1065f300e980e8aae9bd5.png" />
        <p class="error-title">内容违规已被暂停</p>
        <p class="error-text">该内容被多人投诉，为维护绿色上网环境，已停止访问。</p>
      </article>
      <article class="error-removed" v-if="errcode == 807">
        <img class="error-removed__icon"
          src="https://cdn-xcxcustom.weiyoubot.cn/20210615/8ff8b64c0ef1065f300e980e8aae9bd5.png" alt="活动不存在" />
        <p class="error-removed__title">活动不存在</p>
        <p class="error-removed__desc">被删除或被清理的活动可前往回收站查看</p>
        <div class="error-removed__meta">
          <div class="error-removed__row">
            <span class="error-removed__label">网络：</span>
            <span class="error-removed__value">{{ getNetworkTypeText() }}</span>
          </div>
          <div class="error-removed__row">
            <span class="error-removed__label">浏览器：</span>
            <span class="error-removed__value">{{ getBrowserTypeText() }}</span>
          </div>
          <div class="error-removed__row">
            <span class="error-removed__label">昵称：</span>
            <span class="error-removed__value">{{ getCurrentNickname() }}</span>
          </div>
          <div class="error-removed__row error-removed__row--full">
            <span class="error-removed__label">链接：</span>
            <span class="error-removed__value error-removed__value--link">{{ getCurrentLink() }}</span>
          </div>
        </div>
        <div class="error-removed__actions">
          <button type="button" class="error-removed__btn" @click="toMyCheckinList(13)">查看回收站</button>
          <button type="button" class="error-removed__btn" @click="toMyCheckinList()">我的记录</button>
        </div>
        <a
          class="error-removed__banner-link"
          href="https://xcx.qunsou.co/recommend.html?appId=wxfaa08012777a431e"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            class="error-removed__banner"
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-05-20/1b095d6c421109db2e2d0fd9f1cefc0f.png"
            alt="推荐工具"
          />
        </a>
      </article>
    </section>
    <!-- 可以拿到签到的信息，但是设置了加入审核导致不可展示 -->
    <section v-if="audit_status == 'ready'" class="audit-box padding-20-30" aria-label="审核状态">
      <van-image class="audit-img"
        src="http://image-custom.xiaoqiandao.com/20191218/c90a00864ce1b1e19c5740791a556d37.png" />
      <span class="text-28-99">发起人正在审核中，如果等待时间过长，可以自行联系发起人【<span style="color:#12b7f5">{{ audit_name }}</span>】确认原因</span>
    </section>
    <section v-if="audit_status == 'reject'" class="audit-box padding-20-30" aria-label="审核状态">
      <van-image class="audit-img"
        src="https://cdn-xcxcustom.weiyoubot.cn/20200518/8bbaa03c8c9226f142af2b27e9b40f45.png" />
      <span class="text-28-99">您参与签到的申请已被拒绝，如有疑问请联系发起人【<span style="color:#12b7f5">{{ audit_name }}</span>】确认原因</span>
    </section>
    <!-- 可以拿到签到信息展示签到信息 -->
    <article class="content" v-if="checkin != null" @click="openMiniDialog($event)">
      <section class="flex-column" aria-label="签到详情内容">
        <!-- 签到头部 -->
        <checkin-top :checkin="checkin"></checkin-top>
        <!-- 活动说明 -->
        <activity-box
          :checkin="checkin"
          :enable-wx-launch="showDialogWxLaunchTag"
          :mini-path="legacyDetailMiniPath"
          :mini-program-app-id="miniProgramAppId"
          :mini-program-username="miniProgramGhId"
          @open-mini-tip="openMiniTipMessage"
        ></activity-box>
        <menu-box :checkin="checkin" :has-user-info="hasUserInfo" :enable-wx-menu-launch="canLaunchMenuByWxTag"
          :notice-mini-path="noticeMiniPath" :setting-mini-path="settingMiniPath"
          :mini-program-app-id="miniProgramAppId" :mini-program-username="miniProgramGhId"
          @action="handleMenuAction"></menu-box>
        <section v-if="showMeetingRequirements" class="meeting-requirements">
          <div class="meeting-requirements__title">签到要求</div>
          <div class="meeting-requirements__item" v-for="(item, index) in meetingRequirementList" :key="`req-${index}`">{{ item }}</div>
        </section>
        <section v-if="hasUserInfo && checkin && checkin.template == 1" class="calendar-guide top-20" @click="toMyRecord">
          <div class="calendar-guide__left">
            <img class="calendar-guide__avatar" :src="checkin.user_avatar || defaultAvatar" @error="onCalendarAvatarError" alt="头像" />
            <div class="calendar-guide__name">{{ checkin.alias || '我的签到' }}</div>
          </div>
          <div class="calendar-guide__right">
            <span>签到日历</span>
            <img class="calendar-guide__arrow" src="@/assets/icon/right_arrow_blue.png" alt="进入" />
          </div>
        </section>
        <section v-if="checkin.template == 1" class="meeting-detail top-20">
          <div class="meeting-detail__header">会议详情</div>
          <div class="meeting-detail__content" v-if="hasMeetingContent">
            <activity-content :content="checkin.content"></activity-content>
          </div>
          <div class="meeting-detail__empty" v-else>暂无详情</div>
        </section>
        <section v-if="checkin.template == 1" class="meeting-sheet">
          <div class="checkin-record-header">
            <div class="meeting-sheet-head">
              <div class="checkin-record-header-label">签到数据</div>
              <button type="button" :class="['meeting-sheet-tag', meetingSheetType == 0 ? 'meeting-sheet-tag--active' : '']" @click.stop="changeMeetingSheetType(0)">今天</button>
              <button type="button" :class="['meeting-sheet-tag', meetingSheetType == 5 ? 'meeting-sheet-tag--active' : '']" @click.stop="openMeetingDatePicker">{{ meetingSheetDateText || '选择日期' }}</button>
            </div>
            <button v-if="!meetingSheetTip" type="button" class="btn-message-second" @click.stop="toMeetingSheetDownload">
              <img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-30/8ef85a5e0e4dbda033f4c56ea70112bc.png" alt="下载" />
              下载
            </button>
          </div>
          <div v-if="meetingSheetTip" class="show-sheet-tip">{{ meetingSheetTip }}</div>
          <div v-else-if="meetingSheetLoading" class="show-sheet-tip">签到数据加载中...</div>
          <div v-else-if="meetingSheetRows.length > 0" class="meeting-sheet-table-wrap">
            <table class="meeting-sheet-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>昵称</th>
                  <th>签到名字</th>
                  <th>{{ meetingSheetRangeText }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in meetingSheetRows" :key="`${item.unionid || 'u'}-${index}`">
                  <td>{{ item.rank || index + 1 }}</td>
                  <td>{{ item.uname || '匿名用户' }}</td>
                  <td>{{ item.sign_name || item.uname || '匿名用户' }}</td>
                  <td>{{ item.time_text || '--' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="no-more-data">
            <img class="empty-img" src="https://cdn-xcxcustom.weiyoubot.cn/20210308/ccc979e23a23fda7baee0d9640c1334f.png" alt="暂无签到数据" />
            <div class="empty-text">暂无签到数据</div>
          </div>
          <van-popup v-model="showMeetingDatePicker" position="bottom">
            <van-datetime-picker
              v-model="meetingPickerDate"
              type="date"
              :min-date="meetingMinDate"
              :max-date="meetingMaxDate"
              @cancel="showMeetingDatePicker = false"
              @confirm="confirmMeetingDate"
            ></van-datetime-picker>
          </van-popup>
        </section>
        <!-- <section v-if="checkin.template == 1" class="meeting-sheet-footer">
          <button v-if="!meetingSheetTip" type="button" class="meeting-sheet-footer__more" @click.stop="toMeetingSheet">
            查看更多签到数据
            <img src="@/assets/icon/right_arrow_blue.png" alt="进入" />
          </button>
          <div v-else class="meeting-sheet-footer__placeholder"></div>
        </section> -->
      </section>
      <!-- <div class="sign-code" v-if="!is_can_sign || isHide">     
        <img class="sign-img" :src="minQrcode" alt="签到小程序码" />
      </div> -->
    </article>
    <section class="detail-fixed-bar" v-if="checkin != null" v-show="showBottomAction" aria-label="底部操作栏">
      <button type="button" class="detail-fixed-bar__side-btn" @click.stop="toMyCheckinList">
        <img class="detail-fixed-bar__side-icon" src="@/assets/icon/icon_user.png" alt="我的" />
        <span>我的</span>
      </button>
      <button type="button" class="detail-fixed-bar__side-btn" @click.stop="openBottomShare">
        <img class="detail-fixed-bar__side-icon"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230131/2459223c5ff026f01ba89b49d4308009.png" alt="分享" />
        <span>分享</span>
      </button>
      <div class="detail-fixed-bar__main">
        <section class="sign-panel" aria-label="签到操作区">
          <div class="wx-panel" v-if="!is_can_sign && !isHide && checkin && checkin.template != 2">
            <wx-launch-weapp-trigger class="wx-btn" :enabled="true" :appid="miniProgramAppId"
              :username="miniProgramGhId" :path="legacyDetailMiniPath" template-width="100%" template-height="40px"
              :show-fallback="false"></wx-launch-weapp-trigger>
          </div>
          <div v-if="checkin.template == 0">
            <button type="button" @click.stop="showDialog(2)" v-if="checkin.status == 2"
              class="button gray button--with-wx-trigger">
              签到已结束{{ endDateSuffix }}
              <wx-launch-weapp-trigger v-if="showDialogWxLaunchTag" class="button-wx-trigger" :enabled="true"
                :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath" template-width="100%"
                template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
            </button>
            <button type="button" @click.stop="joinCheckin" v-else-if="checkin.has_joined == 0"
              class="button yellow button--with-wx-trigger">
              参与签到
              <wx-launch-weapp-trigger v-if="showJoinWxLaunchTag" class="button-wx-trigger" :enabled="true"
                :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath" template-width="100%"
                template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
            </button>
            <button type="button" @click.stop="showDialog(1)" v-else-if="checkin.status == 0"
              class="button gray button--with-wx-trigger">
              签到未开始{{ startDateSuffix }}
              <wx-launch-weapp-trigger v-if="showDialogWxLaunchTag" class="button-wx-trigger" :enabled="true"
                :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath" template-width="100%"
                template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
            </button>
            <button type="button" @click.stop="showDialog(4)" v-else-if="checkin.status == 3"
              class="button gray button--with-wx-trigger">
              {{ checkin.checkinday[0] == 8 ? '本周' : (checkin.checkinday[0] == 9 ? '本月' : '今日') }}不用签到
              <wx-launch-weapp-trigger v-if="showDialogWxLaunchTag" class="button-wx-trigger" :enabled="true"
                :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath" template-width="100%"
                template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
            </button>
            <div v-else-if="checkin.status == 1">
              <button type="button" @click.stop="checkinAction"
                v-if="checkin.has_checked < checkin.limit && checkin.time_status == 1" class="button">
                点击签到<span v-if="checkin.limit > 1 && checkin.has_checked < checkin.limit">（已签{{ checkin.has_checked
                  }}次/共{{ checkin.limit }}次）</span>
              </button>
              <button type="button" v-if="checkin.has_checked >= checkin.limit"
                class="button light button--with-wx-trigger" @click.stop="handleCompletedClick">
                {{ completePeriodLabel }}签到已完成
                <wx-launch-weapp-trigger v-if="showCompletedWxLaunchTag" class="button-wx-trigger" :enabled="true"
                  :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath"
                  template-width="100%" template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
              </button>
              <button type="button" @click.stop="showDialog(3)"
                v-if="checkin.has_checked < checkin.limit && checkin.time_status != 1 && checkin.time_status != 0"
                class="button light button--with-wx-trigger">
                不在签到时间内
                <wx-launch-weapp-trigger v-if="showDialogWxLaunchTag" class="button-wx-trigger" :enabled="true"
                  :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath"
                  template-width="100%" template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
              </button>
              <button type="button" v-if="checkin.has_checked < checkin.limit && checkin.time_status == 0"
                class="button light button--with-wx-trigger" @click.stop="handleCurrentPeriodSignedClick">
                当前时段已签到
                <wx-launch-weapp-trigger v-if="showCompletedWxLaunchTag" class="button-wx-trigger" :enabled="true"
                  :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath"
                  template-width="100%" template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
              </button>
            </div>
          </div>
          <!-- 会议签到 -->
          <div v-if="checkin.template == 1">
            <button type="button" @click.stop="joinCheckin" v-if="checkin.status != 2 && checkin.has_joined == 0"
              class="button yellow button--with-wx-trigger">
              参与签到
              <wx-launch-weapp-trigger v-if="showJoinWxLaunchTag" class="button-wx-trigger" :enabled="true"
                :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath" template-width="100%"
                template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
            </button>
            <div v-else>
              <button type="button" @click.stop="checkinAction" v-if="checkin.status == 1 && checkin.time_status == 1"
                class="button">点击签到
              </button>
              <button type="button" @click.stop="handleCompletedClick"
                v-else-if="checkin.status == 1 && checkin.time_status == 0 && checkin.time_list.length == 1"
                class="button light button--with-wx-trigger">
                {{ completePeriodLabel }}签到已完成
                <wx-launch-weapp-trigger v-if="showCompletedWxLaunchTag" class="button-wx-trigger" :enabled="true"
                  :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath"
                  template-width="100%" template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
              </button>
              <button type="button" @click.stop="showDialog(3)"
                v-if="checkin.status == 1 && checkin.time_status != 1 && checkin.time_status != 0"
                class="button light button--with-wx-trigger">
                不在签到时间内
                <wx-launch-weapp-trigger v-if="showDialogWxLaunchTag" class="button-wx-trigger" :enabled="true"
                  :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath"
                  template-width="100%" template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
              </button>
              <button type="button" v-if="checkin.status == 1 && checkin.time_status == 0 && checkin.time_list.length > 1"
                class="button light button--with-wx-trigger" @click.stop="handleCurrentPeriodSignedClick">
                当前时段已签到
                <wx-launch-weapp-trigger v-if="showCompletedWxLaunchTag" class="button-wx-trigger" :enabled="true"
                  :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath"
                  template-width="100%" template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
              </button>
              <button type="button" @click.stop="showDialog(1)" v-else-if="checkin.status == 0"
                class="button gray button--with-wx-trigger">
                签到未开始{{ startDateSuffix }}
                <wx-launch-weapp-trigger v-if="showDialogWxLaunchTag" class="button-wx-trigger" :enabled="true"
                  :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath"
                  template-width="100%" template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
              </button>
              <button type="button" @click.stop="showDialog(2)" v-if="checkin.status == 2"
                class="button gray button--with-wx-trigger">
                签到已结束{{ endDateSuffix }}
                <wx-launch-weapp-trigger v-if="showDialogWxLaunchTag" class="button-wx-trigger" :enabled="true"
                  :appid="miniProgramAppId" :username="miniProgramGhId" :path="legacyDetailMiniPath"
                  template-width="100%" template-height="40px" :show-fallback="false"></wx-launch-weapp-trigger>
              </button>
            </div>
          </div>
          <!-- 班级签到 -->
          <div v-if="checkin.template == 2">
            <button type="button" @click.stop="joinCheckin" v-if="checkin.status != 2 && checkin.has_joined == 0"
              class="button yellow button--with-wx-trigger">
              参与签到
              <wx-launch-weapp-trigger
                v-if="showJoinWxLaunchTag"
                class="button-wx-trigger"
                :enabled="true"
                :appid="miniProgramAppId"
                :username="miniProgramGhId"
                :path="legacyDetailMiniPath"
                template-width="100%"
                template-height="40px"
                :show-fallback="false"
              ></wx-launch-weapp-trigger>
            </button>
            <button type="button" v-else class="button" @click.stop="toAllWorkFromBottom">点击签到</button>
          </div>
        </section>
      </div>
    </section>
    <section v-if="showClassMemberBar" class="class-member-bar top-20" @click="handleClassMemberClick">
      <div class="class-member-bar__left">
        <span class="class-member-bar__icon">员</span>
        <span>班级成员（{{ checkin.join_num || 0 }}）</span>
      </div>
      <div class="class-member-bar__right">
        <span>{{ classMemberActionText }}</span>
        <img class="class-member-bar__arrow" src="@/assets/icon/right_arrow_blue.png" alt="进入" />
      </div>
      <wx-launch-weapp-trigger
        v-if="showDialogWxLaunchTag"
        class="class-member-bar__wx-trigger"
        :enabled="true"
        :appid="miniProgramAppId"
        :username="miniProgramGhId"
        :path="legacyDetailMiniPath"
        template-width="100%"
        template-height="43px"
        :show-fallback="false"
      ></wx-launch-weapp-trigger>
    </section>
    <section v-if="hasUserInfo && checkin && checkin.template != 1" class="calendar-guide top-20" @click="toMyRecord">
      <div class="calendar-guide__left">
        <img class="calendar-guide__avatar" :src="checkin.user_avatar || defaultAvatar" @error="onCalendarAvatarError" alt="头像" />
        <div class="calendar-guide__name">{{ checkin.alias || '我的签到' }}</div>
        <!-- <img class="calendar-guide__edit" src="@/assets/icon/ic_edit_blue.png" alt="编辑" /> -->
      </div>
      <div class="calendar-guide__right">
        <span>签到日历</span>
        <img class="calendar-guide__arrow" src="@/assets/icon/right_arrow_blue.png" alt="进入" />
      </div>
    </section>
    <work-box
      v-if="checkin && checkin.template == 2"
      class="top-20"
      :checkin="checkin"
      @action="handleWorkAction"
    ></work-box>
    <!-- 签到动态(会议和班级不展示签到动态) -->
    <record-list v-if="hasUserInfo && checkin && checkin.template != 2 && !(checkin.cate == 0 && checkin.template == 1)"
      class="top-20" :checkin="checkin" :hasUserInfo="hasUserInfo" :participant-mode="true"></record-list>
    <section v-if="showPcAdSlot" class="pc-ad-slot" aria-label="小程序广告位">
      <div class="pc-ad-slot__card">
        <img class="pc-ad-slot__qr" :src="pcAdQrcode" alt="微信扫一扫打开小程序" />
        <div class="pc-ad-slot__tip">微信扫一扫<br />打开小程序</div>
      </div>
      <a class="pc-ad-slot__cta" href="https://xiaoqiandao.com/" target="_blank" rel="noopener noreferrer">
        我也要创建活动
      </a>
    </section>
    <!-- 电脑端扫码弹窗 -->
    <mini-dialog :showMini="showMiniDialog" :message="miniDialogMessage" :cid="checkin ? checkin.cid : ''"
      @close="showMiniDialog = false"></mini-dialog>

    <pc-login-dialog :show="showPcLoginDialog" @close="handlePcLoginClose"
      @success="handlePcLoginSuccess"></pc-login-dialog>

    <div v-if="showSharePanel" class="share-panel" role="dialog" aria-modal="true" aria-labelledby="share-panel-title"
      @click="closeSharePanel">
      <div class="share-panel__mask"></div>
      <div class="share-panel__body" @click.stop>
        <div id="share-panel-title" class="share-panel__title">选择分享方式</div>
        <div class="share-panel__grid">
          <button type="button" class="share-panel__item" @click="shareToFriend">
            <img class="share-panel__icon" src="@/assets/share/ic_s_wxfriend.png" alt="微信好友" />
            <div class="share-panel__text">微信好友</div>
          </button>
          <button type="button" class="share-panel__item" @click="goShareImgPage(1)">
            <img class="share-panel__icon" src="@/assets/share/ic_s_poster.png" alt="海报分享图" />
            <div class="share-panel__text">海报分享图</div>
          </button>
          <button type="button" class="share-panel__item" @click="openMiniProgramDialog(1)">
            <img class="share-panel__icon" src="@/assets/share/ic_s_applet.png" alt="小程序链接" />
            <div class="share-panel__text">小程序链接</div>
          </button>
          <button type="button" class="share-panel__item" @click="goShareImgPage(2)">
            <img class="share-panel__icon" src="@/assets/share/ic_s_code.png" alt="二维码" />
            <div class="share-panel__text">二维码</div>
          </button>
          <button type="button" class="share-panel__item" @click="goShareImgPage(3)">
            <img class="share-panel__icon" src="@/assets/share/ic_s_link.png" alt="网页链接" />
            <div class="share-panel__text">网页链接</div>
          </button>
          <button type="button" class="share-panel__item" @click="goShareImgPage(0)">
            <img class="share-panel__icon" src="@/assets/share/ic_s_longpic.png" alt="日签分享图" />
            <div class="share-panel__text">日签分享图</div>
          </button>
          <button type="button" class="share-panel__item" @click="openMiniProgramDialog(0)">
            <img class="share-panel__icon"
              src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2026-02-02/d89f2a3df092c47d3737c08400ef5444.png"
              alt="接入公众号" />
            <div class="share-panel__text">接入公众号</div>
          </button>
        </div>
        <button type="button" class="share-panel__cancel" @click="closeSharePanel">取消</button>
      </div>
    </div>

    <div v-if="showMiniProgramDialog" class="share-link" role="dialog" aria-modal="true" aria-label="小程序分享路径"
      @click="showMiniProgramDialog = false">
      <div class="share-link__mask"></div>
      <div class="share-link__body share-link__body--path" @click.stop>
        <button type="button" class="share-path__close" aria-label="关闭弹窗" @click="showMiniProgramDialog = false">
          <img src="@/assets/icon/ic_popup_close.png" alt="关闭" />
        </button>
        <div class="share-path__tabs">
          <button type="button"
            :class="['share-path__tab', miniProgramDialogTab === 0 ? 'share-path__tab--active' : '']"
            :aria-pressed="miniProgramDialogTab === 0 ? 'true' : 'false'" @click="miniProgramDialogTab = 0">
            嵌入微信公众号
          </button>
          <button type="button"
            :class="['share-path__tab', miniProgramDialogTab === 1 ? 'share-path__tab--active' : '']"
            :aria-pressed="miniProgramDialogTab === 1 ? 'true' : 'false'" @click="miniProgramDialogTab = 1">
            嵌入自有小程序
          </button>
        </div>

        <div v-if="miniProgramDialogTab === 0" class="share-path__content">
          <div class="share-path__item">
            <div class="share-path__label">AppID:</div>
            <div class="share-path__row">
              <div class="share-path__value">{{ miniProgramAppId }}</div>
              <button type="button" class="share-path__copy" @click="copyText(miniProgramAppId, 'AppID已复制')">复制</button>
            </div>
          </div>
          <div class="share-path__item">
            <div class="share-path__label">小程序路径:</div>
            <div class="share-path__row">
              <div class="share-path__value">{{ miniProgramPath }}</div>
              <button type="button" class="share-path__copy" @click="copyText(miniProgramPath, '小程序路径已复制')">复制</button>
            </div>
            <div class="share-path__tip">
              在公众号菜单、文章里或在其他小程序里插入「小小签到」时，填写上方路径即可正确跳转。更多详细说明和操作步骤，
              <a class="share-path__tip-link" href="https://mp.weixin.qq.com/s/HorSK7kii167pVrALUtk_g"
                target="_blank">点击查看 ></a>
            </div>
          </div>
          <div class="share-path__item">
            <div class="share-path__label">账号原始ID:</div>
            <div class="share-path__row">
              <div class="share-path__value">{{ miniProgramGhId }}</div>
              <button type="button" class="share-path__copy" @click="copyText(miniProgramGhId, '原始ID已复制')">复制</button>
            </div>
          </div>
        </div>

        <div v-else class="share-path__content">
          <div class="share-path__item">
            <div class="share-path__label">小程序打开小程序:</div>
            <div class="share-path__code">{{ miniProgramCode }}</div>
          </div>
          <div class="share-path__tip">
            采用微信提供的“导航 Navigator”的方案，直接复制“全屏打开”的代码，然后按照小程序跳转组件配置进自有小程序代码中即可。
          </div>
          <div class="share-path__actions">
            <button type="button" class="share-path__copy-btn" @click="copyText(miniProgramCode, '代码已复制')">复制代码</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showShareGuide" class="share-guide" @click="showShareGuide = false">
      <div class="share-guide__content">
        <div class="share-guide__arrow">
          <img src="@/assets/icon/ic_mask_arrow.png" alt="share arrow" />
        </div>
        <div class="share-guide__center">
          <div class="share-guide__desc">邀请链接已复制到剪切板</div>
          <div class="share-guide__desc">也可以点击右上角“...”完成分享</div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { getQueryString, getPc, getToken, triggerLoginFlow, PC_LOGIN_REQUIRED_EVENT, isIos, formatDate, getAndroidMiniPath, isWeixin, wxLogin, tryLaunchMiniProgramOnPc } from '@/utils/common.js'
import { Dialog, Toast } from 'vant'
import http from '@/utils/http'
import api from '@/utils/api'
import CheckinTop from '@/components/CheckinTop.vue'
import ActivityBox from '@/components/ActivityBox.vue'
import ActivityContent from '@/components/ActivityContent.vue'
import MenuBox from '@/components/MenuBox.vue'
import RecordList from '@/components/RecordList.vue'
import MiniDialog from '@/components/MiniDialog.vue'
import PcLoginDialog from '@/components/PcLoginDialog.vue'
import WxLaunchWeappTrigger from '@/components/WxLaunchWeappTrigger.vue'
import WorkBox from '@/components/WorkBox.vue'
import defaultAvatar from '@/assets/icon/default_avatar.png'
import { applySeo, setJsonLd, removeJsonLd, toAbsoluteUrl } from '@/utils/seo'
export default {
  name: 'checkin',
  data: () => {
    return {
      showLoadErr: 0, //是否显示加载失败
      errcode: 0, //出现错误的错误码
      checkin: null, //获取到的签到信息
      hasUserInfo: getToken() ? true : false,

      audit_status: '', // 加入需要审核的签到的审核状态 审核中=ready 被拒绝 reject
      audit_tip: '',
      audit_name: '',
      miniMessage: '',
      minQrcode: '',
      refer_uid: '',
      is_can_sign: false,
      isHide: false,
      showMiniDialog: false, // 控制电脑端扫码弹窗显示
      miniDialogMessage: '请去「小小签到」小程序查看',
      showPcLoginDialog: false,
      showSharePanel: false,
      showShareGuide: false,
      showMiniProgramDialog: false,
      miniProgramDialogTab: 0,
      pendingMenuAction: '',
      pendingJoinCheckin: false,
      pendingToMyCheckin: false,
      pendingMyCheckinTab: 0,
      pcAdQrcode: '',
      defaultAvatar,
      meetingSheetLoading: false,
      meetingSheetRows: [],
      meetingSheetType: 0, // 0=今天, 5=选择日期
      meetingSheetDateText: '',
      showMeetingDatePicker: false,
      meetingPickerDate: new Date(),
      meetingMinDate: new Date(2020, 0, 1),
      meetingMaxDate: new Date(),
    }
  },
  components: {
    CheckinTop,
    ActivityBox,
    ActivityContent,
    MenuBox,
    RecordList,
    MiniDialog,
    PcLoginDialog,
    WxLaunchWeappTrigger,
    WorkBox,
  },
  computed: {
    showBottomAction() {
      return !this.showPcLoginDialog &&
        !this.showSharePanel &&
        !this.showShareGuide &&
        !this.showMiniProgramDialog
    },
    showPcAdSlot() {
      return this.isPcBrowser() && !!this.checkin && !!this.pcAdQrcode
    },
    showClassMemberBar() {
      if (!this.checkin || this.checkin.template != 2) {
        return false
      }
      return this.checkin.is_owner == 1 || this.checkin.is_admin == 1 || this.checkin.no_forward != 1
    },
    classMemberActionText() {
      if (!this.checkin) {
        return '邀请新成员'
      }
      return this.checkin.is_owner == 1 || this.checkin.is_admin == 1 ? '成员管理' : '邀请新成员'
    },
    showMeetingRequirements() {
      return !!this.checkin &&
        this.checkin.template == 1 &&
        this.meetingRequirementList.length > 0
    },
    meetingRequirementList() {
      if (!this.checkin || this.checkin.template != 1) {
        return []
      }
      const result = []
      if (Array.isArray(this.checkin.wifis) && this.checkin.wifis.length > 0) {
        result.push('需连接指定 WiFi 才可签到')
      }
      if (Array.isArray(this.checkin.locations) && this.checkin.locations.length > 0) {
        result.push('需在指定地点范围内签到')
      }
      if (this.checkin.scan_required == 1) {
        result.push('需扫码后方可参与签到')
      }
      return result
    },
    hasMeetingContent() {
      return !!this.checkin &&
        this.checkin.template == 1 &&
        Array.isArray(this.checkin.content) &&
        this.checkin.content.length > 0
    },
    meetingSheetTip() {
      if (!this.checkin || this.checkin.template != 1) {
        return ''
      }
      const isManager = this.checkin.is_owner == 1 || this.checkin.is_admin == 1
      if (isManager) {
        return ''
      }
      if (this.checkin.has_joined == 0 && this.checkin.sheet_visible == 2) {
        return '未加入团队，暂时无法查看签到数据'
      }
      if (this.checkin.sheet_visible == 0) {
        return '仅管理员可见，查看签到数据请联系管理员'
      }
      return ''
    },
    meetingSheetRangeText() {
      if (this.meetingSheetType == 5 && this.meetingSheetDateText) {
        return this.meetingSheetDateText
      }
      return '00:00-23:59'
    },
    endDateSuffix() {
      if (!this.checkin || !this.checkin.end_date) {
        return ''
      }
      const endDate = Number(this.checkin.end_date)
      if (!endDate || endDate <= 0) {
        return ''
      }
      return ` （${formatDate(new Date(endDate * 1000), 'yyyy-MM-dd')}）`
    },
    startDateSuffix() {
      if (!this.checkin || !this.checkin.start_date) {
        return ''
      }
      const startDate = Number(this.checkin.start_date)
      if (!startDate || startDate <= 0) {
        return ''
      }
      return ` （${formatDate(new Date(startDate * 1000), 'yyyy-MM-dd')}）`
    },
    shareUrl() {
      if (!this.checkin) {
        return window.location.href
      }
      const referUid = this.checkin.unionid || ''
      return `${window.location.origin}/detail?cid=${this.checkin.cid}&r=${referUid}`
    },
    miniProgramAppId() {
      return 'wxee55405953922c86'
    },
    miniProgramGhId() {
      return 'gh_eedd8c096654'
    },
    miniProgramPath() {
      if (!this.checkin) {
        return '/pages/index/index'
      }
      if (this.checkin.template == 1) {
        return `/pages/detailmeeting/detailmeeting?cid=${this.checkin.cid}`
      }
      if (this.checkin.template == 2) {
        return `/pages/detailwork/detailwork?cid=${this.checkin.cid}`
      }
      return `/pages/detail/detail?cid=${this.checkin.cid}`
    },
    legacyDetailMiniPath() {
      if (!this.checkin || !this.checkin.cid) {
        return ''
      }
      return `/pages/detail/detail.html?cid=${this.checkin.cid}`
    },
    miniProgramCode() {
      return `wx.navigateToMiniProgram({ appId:'${this.miniProgramAppId}', path:'${this.miniProgramPath}' })`
    },
    canLaunchMenuByWxTag() {
      const pcType = getPc()
      return this.hasUserInfo && (pcType == 2 || pcType == 3)
    },
    completePeriodLabel() {
      if (!this.checkin || !Array.isArray(this.checkin.checkinday) || this.checkin.checkinday.length < 1) {
        return '今日'
      }
      if (this.checkin.checkinday[0] == 8) {
        return '本周'
      }
      if (this.checkin.checkinday[0] == 9) {
        return '本月'
      }
      return '今日'
    },
    showJoinWxLaunchTag() {
      return !!getToken() &&
        !this.is_can_sign &&
        !!this.miniMessage &&
        !this.isGroupMemberLimited(this.checkin) &&
        this.isWechatMobileBrowser() &&
        !!this.legacyDetailMiniPath
    },
    showCompletedWxLaunchTag() {
      return this.isWechatMobileBrowser() && !!this.legacyDetailMiniPath
    },
    showDialogWxLaunchTag() {
      return this.isWechatMobileBrowser() && !!this.legacyDetailMiniPath
    },
    menuMiniBasePath() {
      if (!this.checkin) {
        return ''
      }
      return getAndroidMiniPath(this.checkin.template, this.checkin.cid)
    },
    noticeMiniPath() {
      if (!this.menuMiniBasePath) {
        return ''
      }
      return `${this.menuMiniBasePath}&menuAction=notice`
    },
    settingMiniPath() {
      if (!this.menuMiniBasePath) {
        return ''
      }
      return `${this.menuMiniBasePath}&menuAction=setting`
    },
    /**
     * 当前用户是否被活动发起人的不允许转发配置限制分享。
     *
     * @returns {boolean} true 表示只能展示提示弹窗，false 表示可继续正常分享。
     */
    shareDisabledByOwner() {
      return !!this.checkin &&
        this.checkin.no_forward == 1 &&
        this.checkin.is_owner != 1 &&
        this.checkin.is_admin != 1
    }
  },
  created() {
    this.applyDefaultDetailSeo()
    // 允许网络层（如拦截器）通过全局事件通知当前页拉起 PC 扫码登录弹窗。
    window.addEventListener(PC_LOGIN_REQUIRED_EVENT, this.handleGlobalLoginRequired)
    //判断是否是微信web
    if (getPc() != 2 && getPc() != 3) {
      this.isHide = true
      this.getCheckin()
      return
    }

    // 判断是否可以获得token
    if (!getToken()) {
      triggerLoginFlow({ onPcLogin: this.openPcLoginDialog }).then(() => {
        this.getCheckin()
      })
    } else {
      this.getCheckin()
    }
  },
  beforeDestroy() {
    window.removeEventListener(PC_LOGIN_REQUIRED_EVENT, this.handleGlobalLoginRequired)
    removeJsonLd('checkin-detail-event')
  },
  methods: {
    isPcBrowser() {
      return getPc() == 0
    },
    isWechatBrowser() {
      return isWeixin()
    },
    isWechatMobileBrowser() {
      const pcType = getPc()
      return pcType == 2 || pcType == 3
    },
    getNetworkTypeText() {
      const nav = window.navigator || {}
      const conn = nav.connection || nav.mozConnection || nav.webkitConnection
      const raw = (conn && (conn.effectiveType || conn.type)) ? String(conn.effectiveType || conn.type).toLowerCase() : ''
      if (!raw) {
        return '未知'
      }
      if (raw.indexOf('wifi') > -1) {
        return 'wifi'
      }
      if (raw.indexOf('4g') > -1) {
        return '4g'
      }
      if (raw.indexOf('5g') > -1) {
        return '5g'
      }
      if (raw.indexOf('3g') > -1) {
        return '3g'
      }
      if (raw.indexOf('2g') > -1) {
        return '2g'
      }
      return raw
    },
    getBrowserTypeText() {
      const ua = (window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : ''
      if (/MicroMessenger/i.test(ua)) {
        return '微信浏览器'
      }
      if (/Edg\//i.test(ua)) {
        return 'Edge浏览器'
      }
      if (/Firefox\//i.test(ua)) {
        return 'Firefox浏览器'
      }
      if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) {
        return 'Safari浏览器'
      }
      if (/Chrome\//i.test(ua)) {
        return 'Chrome浏览器'
      }
      return '未知浏览器'
    },
    getCurrentNickname() {
      try {
        const raw = localStorage.getItem('userInfo') || ''
        const data = raw ? JSON.parse(raw) : {}
        return data.name || data.nickName || data.nickname || data.uname || '未登录用户'
      } catch (e) {
        return '未登录用户'
      }
    },
    getCurrentLink() {
      return window.location.href
    },
    jumpToWxScheme() {
      const wxScheme = this.checkin && this.checkin.wx_scheme ? String(this.checkin.wx_scheme).trim() : ''
      if (!wxScheme) {
        return false
      }
      window.location.href = wxScheme
      return true
    },
    launchMiniProgramOnPc(message = '请去「小小签到」小程序查看') {
      if (!this.isPcBrowser()) {
        return Promise.resolve(false)
      }
      if (!getToken()) {
        // PC 未登录时先走现有扫码登录流程，登录后用户再次点击即可直拉起。
        this.openPcLoginDialog()
        return Promise.resolve(true)
      }
      if (!this.checkin || !this.checkin.cid) {
        // 缺少必要上下文或 SDK 未就绪时，回退到原有二维码弹窗兜底。
        this.miniDialogMessage = message
        this.showMiniDialog = true
        return Promise.resolve(true)
      }
      return tryLaunchMiniProgramOnPc({
        path: this.miniProgramPath,
      }).then((state) => {
        if (state && state.launched) {
          return true
        }
        this.miniDialogMessage = message
        this.showMiniDialog = true
        return true
      }).catch(() => {
        this.miniDialogMessage = message
        this.showMiniDialog = true
        return true
      })
    },
    handleGlobalLoginRequired() {
      if (this.needPcLogin()) {
        this.openPcLoginDialog()
      }
    },
    needPcLogin() {
      return this.isPcBrowser() && !getToken()
    },
    handleCompletedClick() {
      if (this.showCompletedWxLaunchTag) {
        return
      }

      this.miniDialogMessage = `${this.completePeriodLabel}签到已完成`
      if (this.isPcBrowser()) {
        this.launchMiniProgramOnPc(this.miniDialogMessage)
        return
      }
      this.showMiniDialog = true
    },
    handleCurrentPeriodSignedClick() {
      if (this.showCompletedWxLaunchTag) {
        return
      }
      // 与未认证活动按钮保持一致：优先尝试拉起小程序，失败后再弹窗提示。
      this.miniDialogMessage = '当前时段已签到'
      if (this.isPcBrowser()) {
        this.launchMiniProgramOnPc(this.miniDialogMessage)
        return
      }
      this.showMiniDialog = true
    },
    showDialog(flag) {
      if (this.needPcLogin()) {
        this.openPcLoginDialog()
        return
      }

      if (this.showDialogWxLaunchTag) { // 微信环境下如果有小程序路径，优先引导用户使用微信菜单的形式打开小程序
        return
      }

      let message = ''
      if (flag == 1) {
        message =
          '签到还未开始，暂时无法签到，可以先去设置里设置提醒时间，及时收到签到提醒。'
      } else if (flag == 2) {
        message = '签到活动已结束，无法签到'
      } else if (flag == 3) {
        message =
          '现在时间不在发起者设置的签到时间范围内，具体请看签到规则里的每日可签到时间。'
      } else if (flag == 4) {
        message =
          '现在时间不在发起者设置的签到周期范围内，具体请看签到规则里的签到周期。'
      }
      if (message) this.miniDialogMessage = message
      if (this.isPcBrowser()) {
        this.launchMiniProgramOnPc(this.miniDialogMessage)
        return
      }
      this.showMiniDialog = true
    },
    isNeedSign() {
      this.is_can_sign = false
      this.miniMessage = ''
      if (this.checkin.is_owner_cerficated != 1) {
        this.miniMessage = '该签到发起人尚未认证，请在小程序中使用'
        return
      }
      if (this.isGroupMemberLimited(this.checkin)) {
        this.miniMessage = '该签到仅限指定微信群成员参与，请使用小程序加入'
        return
      }
      if (this.checkin.wifis.length > 0) {
        this.miniMessage = '该签到需要检查手机是否连接指定WiFi，请使用小程序签到'
        return
      }
      if (this.checkin.scan_required == 1) {
        this.miniMessage = '该签到需要通过扫码参与，请使用小程序加入'
        return
      }
      if (this.checkin.locations.length > 0) {
        this.miniMessage = '该签到需要获取手机定位，请使用小程序签到'
        return
      }
      if (this.checkin.template == 2) {
        this.miniMessage = '班级签到需要填写相关信息，请使用小程序加入'
        return
      }
      if (this.checkin.enable_audit == 1) {
        this.miniMessage = '该签到需要发起签到审核申请才能参与，请使用小程序加入'
        return
      }
      // 参与签到需要名称与名单一致
      if (this.checkin.disable_free_join == 1) {
        this.miniMessage = '该签到需要填写个人信息后才能加入，请使用小程序加入'
        return
      }
      // 参与签到需要填写口令
      if (!this.checkin.has_joined && this.checkin.req_token) {
        this.miniMessage = '该签到需要填写口令后才能加入，请使用小程序加入'
        return
      }
      // 判断签到是否需要填写除文字外的信息
      let flag = 0
      for (let i = 0; i < this.checkin.fill_options.length; i++) {
        let item = this.checkin.fill_options[i]
        // iOS上传视频不可以
        if (item.field_key == 3 && item.status == 1 && item.require == 1 && isIos()) {
          flag = 1
          break
        }
      }
      if (flag) {
        this.miniMessage = '该签到需要提交指定内容，请使用小程序签到'
      } else {
        this.is_can_sign = true;
      }
    },
    /**
     * 判断当前活动是否开启“仅群成员可参与”限制。
     *
     * @param {Object} checkin 当前签到活动详情，来自详情接口返回值。
     * @returns {boolean} true 表示需要在小程序内获取微信群上下文后才能加入。
     */
    isGroupMemberLimited(checkin) {
      if (!checkin) {
        return false
      }
      // group_enter 是 PC 创建页和小程序设置页约定的“仅群成员可参与”开关字段。
      return Number(checkin.group_enter) === 1
    },
    openPcLoginDialog() {
      this.showPcLoginDialog = true
    },
    handlePcLoginClose() {
      this.showPcLoginDialog = false
      this.pendingMenuAction = ''
      this.pendingJoinCheckin = false
      this.pendingToMyCheckin = false
      this.pendingMyCheckinTab = 0
    },
    handlePcLoginSuccess() {
      this.hasUserInfo = true
      const action = this.pendingMenuAction
      const needJoinCheckin = this.pendingJoinCheckin
      const needGoMyCheckin = this.pendingToMyCheckin
      const pendingTab = this.pendingMyCheckinTab
      this.pendingMenuAction = ''
      this.pendingJoinCheckin = false
      this.pendingToMyCheckin = false
      this.pendingMyCheckinTab = 0
      this.getCheckin(() => {
        if (action) {
          this.handleMenuAction(action, true)
        }
        if (needJoinCheckin) {
          this.joinCheckin()
        }
        if (needGoMyCheckin) {
          const query = pendingTab ? { tab: String(pendingTab) } : {}
          this.$router.push({
            name: 'myCheckin',
            query,
          })
        }
      })
    },
    // 可以签到
    checkinAction() {
      const pcType = getPc()
      const isWechatSignEnv = pcType == 2 || pcType == 3 || (pcType == 0 && this.isWechatBrowser())

      if (isWechatSignEnv && !getToken()) {
        wxLogin().then(() => {
          if (!getToken()) {
            return
          }
          this.hasUserInfo = true
          this.getCheckin(() => {
            this.checkinAction()
          })
        })
        return
      }

      // 手机普通浏览器优先走微信短链直跳小程序。
      if (pcType == 1) {
        if (this.jumpToWxScheme()) {
          return
        }
        this.showMiniDialog = true
        return
      }

      // 其他环境统一走公众号扫码登录弹窗。
      if (!isWechatSignEnv && !getToken()) {
        this.openPcLoginDialog()
        return
      }

      // 未认证活动在 PC 浏览器中不支持 H5 直接签到，已登录也需要引导到小程序。
      if (getToken() && this.isPcBrowser() && this.checkin && this.checkin.is_owner_cerficated != 1) {
        this.miniDialogMessage = '该签到发起人尚未认证，请在小程序中使用'
        this.launchMiniProgramOnPc(this.miniDialogMessage)
        return
      }

      // 前往签到页面
      if (this.checkin.template == 0) {
        // 普通签到
        if (this.checkin.pic_text) {
          localStorage.setItem('checkin', JSON.stringify(this.checkin))
          this.$router.push({
            name: 'checkin',
          })
        } else {
          this.doCheckin()
        }
      }
      if (this.checkin.template == 1) {
        // 会议签到
        this.doCheckin()
      }
    },
    ensureCertifiedForH5Action() {
      if (!this.checkin || this.checkin.is_owner_cerficated == 1) {
        return true
      }
      this.miniDialogMessage = '该签到发起人尚未认证，请在小程序中使用'
      if (this.isPcBrowser()) {
        this.launchMiniProgramOnPc(this.miniDialogMessage)
      } else {
        this.showMiniDialog = true
      }
      return false
    },
    toAllWorkFromBottom() {
      if (!this.checkin || !this.checkin.cid) {
        return
      }
      if (!this.ensureCertifiedForH5Action()) {
        return
      }
      this.$router.push({
        name: 'allwork',
        query: {
          cid: this.checkin.cid,
          type: '1',
          isadmin: (this.checkin.is_owner == 1 || this.checkin.is_admin == 1) ? '1' : '0',
        },
      })
    },
    doCheckin() {
      let data = {
        cid: this.checkin.cid,
        access_token: getToken(),
      }
      http.post(api.checkin.submit, data).then((res) => {
        let { count, rank } = res.data
        Toast.success('签到成功')
        this.$router.push({
          path: '/success',
          query: { count, rank },
        })
      })
    },
    getCheckin(callback) {
      // 获取当前的cid
      let cid = getQueryString('cid')
      this.refer_uid = getQueryString('r') || ''
      if (cid) {
        // 获取考勤详情
        let params = {
          source: 'h5',
          cid: cid,
          random: Math.random(),
        }
        let url = api.checkin.getNoDetail;
        if (getToken()) {
          url = api.checkin.getCheckinDetail;
          params.access_token = getToken();
        }

        http.get(url, params).then(
          (res) => {
            let checkin = res.data
            this.hasUserInfo = !!getToken()
            if (this.isAggregateCheckin(checkin)) {
              this.redirectToAggregateDetail(checkin, cid)
              return
            }
            if (checkin.enable_audit == 1 && checkin.audit_status == 2 && checkin.has_joined == 0) {
              // 加入签到审核中
              this.audit_status = 'ready'
              this.audit_name = checkin.owner
              this.applyDetailNoIndexSeo('签到审核中 - 小小签到', '该页面为签到申请审核状态页，仅对当前用户展示。')
              return
            }
            if (checkin.enable_audit == 1 && checkin.audit_status == 0) {
              // 加入签到被拒绝了
              this.audit_status = 'reject'
              this.audit_name = checkin.owner
              this.applyDetailNoIndexSeo('签到申请被拒绝 - 小小签到', '该页面为签到申请审核结果页，仅对当前用户展示。')
              return
            }
            if (checkin.end_date == checkin.start_date || checkin.has_joined == 0 || !this.hasUserInfo) {
              checkin.canNotShowFlow = 1
            }
            if (checkin.end_date == 0) {
              let date = new Date()
              date.setYear(date.getFullYear() + 100)
              checkin.end_date = date.getTime() / 1000
            }

            this.checkin = checkin
            if (this.checkin.template == 2 && !Array.isArray(this.checkin.homework)) {
              this.checkin.homework = []
            }
            if (this.checkin.template == 1) {
              this.loadMeetingSheetPreview()
            } else {
              this.meetingSheetRows = []
            }
            this.applyDetailSeo(checkin)
            this.initMinImg()
            this.initPcAdQrcode()
            // if(!this.isHide){
            this.isNeedSign()
            // }
            callback && callback()
          },
          (err) => {
            const errData = (err && err.data) || {}
            if (errData.sta == -1) {
              if (errData.errcode) {
                this.errcode = errData.errcode || 0
              } else if (errData.msg && String(errData.msg).indexOf('data not found') > -1) {
                this.errcode = 807
              } else {
                this.errcode = 0
              }
            }
            // 无论后端返回何种错误，异常详情页都不应参与索引。
            this.applyDetailNoIndexSeo('签到访问异常 - 小小签到', '该签到页面当前不可访问或已失效。')
          }
        )
      } else {
        this.applyDetailNoIndexSeo('签到链接错误 - 小小签到', '签到链接参数缺失，页面无法正常访问。')
        Dialog({
          title: '温馨提示',
          message: '分享链接错误，请检查分享链接',
        })
      }
    },
    /**
     * 跳转到聚合签到详情页，保留外部 H5 统一入口 /detail?cid=xxx。
     *
     * @param {Object} checkin 普通详情接口返回的聚合签到数据。
     * @param {String} fallbackCid 当前 URL 上的 cid，接口未返回 cid 时作为兜底。
     */
    redirectToAggregateDetail(checkin, fallbackCid) {
      const aggregateCid = (checkin && checkin.cid) || fallbackCid
      if (!aggregateCid) return
      const navigation = this.$router.replace({
        name: 'detailAggregate',
        query: {
          cid: aggregateCid,
        },
      })
      if (navigation && typeof navigation.catch === 'function') {
        navigation.catch(() => {})
      }
    },
    /**
     * 判断普通详情接口返回的活动是否为聚合签到。
     *
     * @param {Object} checkin 普通详情接口返回的活动数据。
     * @returns {Boolean} true 表示聚合签到。
     */
    isAggregateCheckin(checkin) {
      return !!checkin && Number(checkin.template) === 0 && Number(checkin.cate) === 3
    },
    initMinImg() {
      if (!this.checkin.cid) return;
      let param = {
        cid: this.checkin.cid,
        source: "h5",
      };
      http.get(api.checkin.getQr, param).then((res) => {
        this.minQrcode = res.data.url;
      });
    },
    initPcAdQrcode() {
      if (!this.checkin || !this.checkin.cid || !this.isPcBrowser()) return
      const param = {
        cid: this.checkin.cid,
        source: 'h5',
      }
      http.get(api.checkin.getQrocde, param).then((res) => {
        this.pcAdQrcode = (res && res.data && res.data.url) || ''
      })
    },
    openMiniDialog(event) {
      if (event && event.target) {
        const target = event.target
        if (
          (target.closest && target.closest('.meeting-detail')) ||
          (target.closest && target.closest('.meeting-sheet')) ||
          (target.closest && target.closest('.activity-content')) ||
          target.tagName === 'IMG' ||
          target.tagName === 'VIDEO' ||
          target.tagName === 'A' ||
          target.tagName === 'BUTTON'
        ) {
          return
        }
      }
      if (getPc() != 2 && getPc() != 3) { // 电脑端打开,显示引导弹窗
        this.launchMiniProgramOnPc(this.miniDialogMessage)
        return;
      }
    },
    handleMenuAction(action, skipPcLogin = false) {
      if (!this.checkin) {
        return
      }
      if (action == 'share' && this.shareDisabledByOwner) {
        this.showShareDisabledDialog()
        return
      }
      if (!skipPcLogin && !getToken()) {
        if (this.isPcBrowser()) {
          this.pendingMenuAction = action
          this.openPcLoginDialog()
          return
        }
        triggerLoginFlow({ onPcLogin: this.openPcLoginDialog }).then(() => {
          if (!getToken()) {
            return
          }
          this.hasUserInfo = true
          this.getCheckin(() => {
            if (action == 'notice' || action == 'setting') {
              return
            }
            this.handleMenuAction(action, true)
          })
        })
        return
      }
      if (action == 'notice' || action == 'setting') {
        this.miniDialogMessage = '请去「小小签到」小程序查看'
        if (this.isPcBrowser()) {
          this.launchMiniProgramOnPc(this.miniDialogMessage)
          return
        }
        this.showMiniDialog = true
        return
      }
      if (action == 'share') {
        this.showSharePanel = true
        return
      }
      if (action == 'rank') {
        this.toRank()
        return
      }
      if (action == 'record') {
        this.toMyRecord()
      }
    },
    closeSharePanel() {
      this.showSharePanel = false
    },
    /**
     * 展示活动发起人关闭转发后的邀请分享提示。
     *
     * @returns {void}
     */
    showShareDisabledDialog() {
      Dialog.confirm({
        title: '提示',
        message: '活动设置了不允许转发签到，如有问题请联系【活动发起人】',
        confirmButtonText: '去留言',
        cancelButtonText: '我知道了',
        confirmButtonColor: '#12b7f5',
        cancelButtonColor: '#111111',
      }).then(() => {
        this.toOwnerMessagePage()
      }).catch(() => {})
    },
    /**
     * 跳转到当前活动的留言输入页。
     *
     * @returns {void}
     */
    toOwnerMessagePage() {
      if (!this.checkin || !this.checkin.cid) {
        return
      }
      this.$router.push({
        name: 'commentReply',
        query: {
          type: 'message',
          cid: this.checkin.cid,
          source: 'detail_share_disabled',
        },
      })
    },
    shareToFriend() {
      this.showSharePanel = false
      this.copyShareLink('', false, true)
      this.showShareGuide = true
    },
    goShareImgPage(tab) {
      this.showSharePanel = false
      const shareCheckin = Object.assign({}, this.checkin, {
        minQrcode: this.minQrcode,
      })
      localStorage.setItem('checkin', JSON.stringify(shareCheckin))
      this.$router.push({
        name: 'shareImg',
        query: {
          cid: this.checkin.cid,
          tab,
        },
      })
    },
    openMiniProgramDialog(tab = 0) {
      this.showSharePanel = false
      this.miniProgramDialogTab = tab
      this.showMiniProgramDialog = true
    },
    copyText(value, message = '已复制', needToast = true) {
      const textArea = document.createElement('textarea')
      textArea.value = value
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      if (needToast && message) {
        Toast.success(message)
      }
    },
    copyShareLink(message = '链接已复制', needToast = true, keepGuide = false) {
      this.copyText(this.shareUrl, message, needToast)
      this.showSharePanel = false
      if (!keepGuide) {
        this.showShareGuide = false
      }
    },
    toRank() {
      const checkin = this.checkin
      if (checkin.status == 2 && checkin.has_joined == 0 && checkin.is_owner == 0 && checkin.is_admin == 0) {
        Dialog({
          title: '温馨提示',
          message: '签到活动已结束，无法点击',
          confirmButtonText: '我知道啦',
          confirmButtonColor: '#12b7f5',
        })
        return
      }
      if (checkin.has_joined == 0 && checkin.is_owner == 0) {
        Dialog({
          title: '温馨提示',
          message: '还没有参与签到哦，请先参与后再来点我',
          confirmButtonText: '我知道啦',
          confirmButtonColor: '#12b7f5',
        })
        return
      }
      if (checkin.is_owner == 0 && checkin.is_admin == 0 && checkin.rank_visi == 1) {
        Dialog({
          title: '温馨提示',
          message: '发起者设置了仅管理员可查看，如有问题请联系发起者',
          confirmButtonText: '我知道啦',
          confirmButtonColor: '#12b7f5',
        })
        return
      }
      localStorage.setItem('checkin', JSON.stringify(checkin))
      this.$router.push({
        name: 'rank',
        query: {
          cid: checkin.cid,
          nowork: checkin.disable_homework || 0,
        },
      })
    },
    toMyRecord() {
      localStorage.setItem('checkin', JSON.stringify(this.checkin))
      this.$router.push({
        name: 'userCheckin',
        query: {
          cid: this.checkin.cid,
          unionid: this.checkin.unionid || '',
        },
      })
    },
    handleClassMemberClick() {
      if (!this.checkin || this.checkin.template != 2) {
        return
      }
      if (this.showDialogWxLaunchTag) {
        return
      }
      if (this.checkin.is_owner == 1 || this.checkin.is_admin == 1) {
        this.miniDialogMessage = '请去「小小签到」小程序进行成员管理'
        if (this.isPcBrowser()) {
          this.launchMiniProgramOnPc(this.miniDialogMessage)
          return
        }
        this.showMiniDialog = true
        return
      }
      this.handleMenuAction('share')
    },
    onCalendarAvatarError(event) {
      if (!event || !event.target) {
        return
      }
      event.target.src = this.defaultAvatar
    },
    /**
     * 展示引导用户前往小程序处理的提示。
     *
     * @param {string} message 需要展示给用户的小程序操作提示。
     * @returns {void}
     */
    openMiniTipMessage(message = '请去「小小签到」小程序查看') {
      if (this.showDialogWxLaunchTag) {
        return
      }
      this.miniDialogMessage = message
      if (this.isPcBrowser()) {
        this.launchMiniProgramOnPc(this.miniDialogMessage)
        return
      }
      this.showMiniDialog = true
    },
    toMeetingSheet() {
      if (!this.checkin) {
        return
      }
      this.$router.push({
        name: 'rank',
        query: {
          cid: this.checkin.cid,
          nowork: 1,
        },
      })
    },
    toMeetingSheetDownload() {
      if (!this.checkin) {
        return
      }
      this.$router.push({
        name: 'download',
        query: {
          cid: this.checkin.cid,
          unionid: this.checkin.unionid || '',
        },
      })
    },
    changeMeetingSheetType(type) {
      if (this.meetingSheetType === type) {
        return
      }
      this.meetingSheetType = type
      if (type === 0) {
        this.meetingSheetDateText = ''
      }
      this.loadMeetingSheetPreview()
    },
    openMeetingDatePicker() {
      this.showMeetingDatePicker = true
    },
    confirmMeetingDate(date) {
      this.showMeetingDatePicker = false
      this.meetingPickerDate = date
      this.meetingSheetType = 5
      this.meetingSheetDateText = formatDate(date, 'yyyy-MM-dd')
      this.loadMeetingSheetPreview()
    },
    loadMeetingSheetPreview() {
      if (!this.checkin || this.checkin.template != 1 || this.meetingSheetTip) {
        this.meetingSheetRows = []
        return
      }
      this.meetingSheetLoading = true
      const params = {
        page: 1,
        count: 20,
        type: this.meetingSheetType,
        mode: 0,
        check: 1,
        cid: this.checkin.cid,
        access_token: getToken(),
      }
      if (this.meetingSheetType == 5 && this.meetingSheetDateText) {
        const [y, m, d] = this.meetingSheetDateText.split('-').map((v) => Number(v))
        const startTime = Math.floor(new Date(y, m - 1, d, 0, 0, 0).getTime() / 1000)
        params.start_time = startTime
        params.end_time = startTime + 24 * 60 * 60
      }
      http.get(api.checkin.rankList, params).then((res) => {
        const ranks = (res && res.data) || {}
        const checkList = Array.isArray(ranks.check_list) ? ranks.check_list : []
        this.meetingSheetRows = checkList.map((item) => {
          const time = item && item.time ? Number(item.time) : 0
          return Object.assign({}, item, {
            sign_name: item.name || item.alias || item.uname || '',
            time_text: time > 0 ? formatDate(new Date(time * 1000), 'HH:mm') : ''
          })
        })
      }).catch(() => {
        this.meetingSheetRows = []
      }).finally(() => {
        this.meetingSheetLoading = false
      })
    },
    handleWorkAction(action) {
      if (!action || !this.checkin || !this.checkin.cid) {
        return
      }
      if (!this.ensureCertifiedForH5Action()) {
        return
      }
      // 兼容旧事件（字符串）和新事件（对象）。
      if (typeof action === 'string') {
        this.handleMenuAction(action)
        return
      }
      const type = action.type || ''
      if (type == 'allwork') {
        this.$router.push({
          name: 'allwork',
          query: {
            cid: this.checkin.cid,
            type: '1',
            isadmin: (this.checkin.is_owner == 1 || this.checkin.is_admin == 1) ? '1' : '0',
          },
        })
        return
      }
      if (type == 'workdetail' && action.wid) {
        this.$router.push({
          name: 'workdetail',
          query: {
            cid: this.checkin.cid,
            wid: action.wid,
            isadmin: (this.checkin.is_owner == 1 || this.checkin.is_admin == 1) ? '1' : '0',
          },
        })
      }
    },
    toMyCheckinList(defaultTab = 0) {
      if (!getToken()) {
        const pcType = getPc()
        // 手机普通浏览器：优先尝试微信短链唤起；失败则走扫码登录兜底，避免点击无响应。
        if (pcType == 1) {
          if (this.jumpToWxScheme()) {
            return
          }
          this.pendingToMyCheckin = true
          this.pendingMyCheckinTab = defaultTab
          this.openPcLoginDialog()
          return
        }
        if (this.isPcBrowser()) {
          this.pendingToMyCheckin = true
          this.pendingMyCheckinTab = defaultTab
          this.openPcLoginDialog()
          return
        }
        triggerLoginFlow({ onPcLogin: this.openPcLoginDialog }).then(() => {
          if (!getToken()) {
            // 某些环境 triggerLoginFlow 会 skip，这里兜底拉起扫码登录，确保有可执行路径。
            this.pendingToMyCheckin = true
            this.pendingMyCheckinTab = defaultTab
            this.openPcLoginDialog()
            return
          }
          this.hasUserInfo = true
          const query = defaultTab ? { tab: String(defaultTab) } : {}
          this.$router.push({
            name: 'myCheckin',
            query,
          })
        })
        return
      }
      const query = defaultTab ? { tab: String(defaultTab) } : {}
      this.$router.push({
        name: 'myCheckin',
        query,
      })
    },
    openBottomShare() {
      this.handleMenuAction('share')
    },
    // 加入签到
    joinCheckin() {
      const pcType = getPc()
      const isWechatSignEnv = pcType == 2 || pcType == 3 || (pcType == 0 && this.isWechatBrowser())
      // 参与签到必须先有 token，避免未登录时直接请求接口导致 500。
      if (!getToken()) {
        // 手机普通浏览器优先通过微信短链跳转小程序。
        if (pcType == 1) {
          if (this.jumpToWxScheme()) {
            return
          }
          this.openPcLoginDialog()
          return
        }
        // 手机微信/电脑微信浏览器走微信授权登录。
        if (isWechatSignEnv) {
          wxLogin().then(() => {
            if (!getToken()) {
              return
            }
            this.hasUserInfo = true
            this.getCheckin(() => {
              this.joinCheckin()
            })
          })
          return
        }
        if (this.isPcBrowser()) {
          this.pendingJoinCheckin = true
          this.openPcLoginDialog()
          return
        }
        triggerLoginFlow({ onPcLogin: this.openPcLoginDialog }).then(() => {
          if (!getToken()) {
            Dialog({
              title: '温馨提示',
              message: '请先登录后再参与签到',
              confirmButtonText: '我知道啦',
              confirmButtonColor: '#12b7f5',
            })
            return
          }
          this.hasUserInfo = true
          this.getCheckin(() => {
            this.joinCheckin()
          })
        })
        return
      }
      if (this.checkin.is_black == 1) {
        Dialog({
          title: '温馨提示',
          message: '您已被发起者加入黑名单，无法参与签到',
          confirmButtonText: '我知道啦',
          confirmButtonColor: '#12b7f5',
        })
        return
      }
      if (this.checkin.total_limit != 0 && this.checkin.join_num * 1 >= this.checkin.total_limit) {
        Dialog({
          title: '温馨提示',
          message: '该签到参与人数已满',
          confirmButtonText: '我知道啦',
          confirmButtonColor: '#12b7f5',
        })
        return
      }
      if (!this.is_can_sign) {
        if (!this.miniMessage) {
          this.miniDialogMessage = '请去「小小签到」小程序查看'
          if (this.isPcBrowser()) {
            this.launchMiniProgramOnPc(this.miniDialogMessage)
            return
          }
          this.showMiniDialog = true
          return
        }
        if (this.isWechatMobileBrowser() && this.showJoinWxLaunchTag) { // 微信内且满足条件的用户，直接通过微信标签引导去小程序
          return
        }

        //弹窗提示用户去小程序
        this.miniDialogMessage = this.miniMessage
        if (this.isPcBrowser()) {
          this.launchMiniProgramOnPc(this.miniDialogMessage)
          return
        }
        this.showMiniDialog = true
        return
      }
      // 参与签到需要填写个人信息
      if (this.checkin.bind_eid != 0 && (this.checkin.req_name || this.checkin.bind_eid || (this.checkin.reg_info && this.checkin.reg_info.length > 0))) {
        this.checkin.refer_uid = this.refer_uid
        localStorage.setItem('checkin', JSON.stringify(this.checkin))
        this.$router.push({
          name: 'info',
        })
        return
      }
      if (this.checkin.template == 1 || this.checkin.template == 0) {
        //加入签到
        let params = {
          cid: this.checkin.cid,
          access_token: getToken(),
          referer: this.refer_uid,
          refer_type: 29
        }
        http.post(api.checkin.joinCheckin, params).then(() => {
          this.checkin.has_joined = 1
          if (this.checkin.template == 1) {
            this.doCheckin()
            return
          }
          this.$router.go(0)
        })
      }
    },
    // ---------------- SEO 逻辑区（下沉，避免干扰主业务阅读） ----------------
    // 清洗用于 SEO 的文本内容，去除 HTML 标签与多余空白。
    sanitizeSeoText(value) {
      if (!value) {
        return ''
      }
      return String(value)
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    },
    // 将时间戳格式化为 SEO 友好的 yyyy-MM-dd 日期字符串。
    formatSeoDate(value) {
      const time = Number(value)
      if (!time || time <= 0) {
        return ''
      }
      return formatDate(new Date(time * 1000), 'yyyy-MM-dd')
    },
    // 根据活动模板生成页面文案使用的活动类型名称。
    getTemplateLabel(checkin) {
      if (!checkin) {
        return '签到'
      }
      if (checkin.template == 1) {
        return '会议签到'
      }
      if (checkin.template == 2) {
        return '班级签到'
      }
      return '签到'
    },
    // 生成详情页 canonical 地址，仅保留核心参数 cid。
    getDetailCanonicalUrl(cid) {
      const plainCid = this.sanitizeSeoText(cid)
      if (!plainCid) {
        return toAbsoluteUrl('/detail')
      }
      // canonical 仅保留核心参数 cid，避免 r/utm 等参数造成重复收录。
      return toAbsoluteUrl(`/detail?cid=${encodeURIComponent(plainCid)}`)
    },
    // 提取活动说明中的纯文本内容，作为 description 的候选摘要。
    getRuleSummary(checkin) {
      if (!checkin) {
        return ''
      }
      if (Array.isArray(checkin.rules) && checkin.rules.length > 0) {
        const text = checkin.rules
          .filter((item) => item && item.type == 'text' && item.value)
          .map((item) => this.sanitizeSeoText(item.value))
          .filter(Boolean)
          .join(' ')
        if (text) {
          return text
        }
      }
      return this.sanitizeSeoText(checkin.rule || '')
    },
    // 组合详情页 description 文案，覆盖活动类型、发起人、日期和规则摘要。
    buildDetailDescription(checkin, templateLabel) {
      const parts = [`${templateLabel}活动详情`]
      if (checkin && checkin.signature) {
        parts.push(`发起人：${this.sanitizeSeoText(checkin.signature)}`)
      }
      if (checkin && checkin.start_date && checkin.end_date) {
        parts.push(`签到日期：${this.formatSeoDate(checkin.start_date)} 至 ${this.formatSeoDate(checkin.end_date)}`)
      }
      const ruleText = this.getRuleSummary(checkin)
      if (ruleText) {
        parts.push(ruleText.slice(0, 88))
      }
      return parts.join('，')
    },
    // 生成 Event 类型 JSON-LD 结构化数据，提升搜索引擎对活动页的理解。
    buildDetailJsonLd(checkin, canonicalUrl) {
      if (!checkin) {
        return null
      }
      // 把业务数据映射为 Event，帮助搜索引擎理解这是“活动页”而非普通文章页。
      const startTime = Number(checkin.start_date)
      const endTime = Number(checkin.end_date)
      const description = this.buildDetailDescription(checkin, this.getTemplateLabel(checkin))
      const payload = {
        '@context': 'https://schema.org',
        '@type': 'Event',
        name: this.sanitizeSeoText(checkin.title || '签到活动'),
        description,
        url: canonicalUrl,
      }
      if (startTime > 0) {
        payload.startDate = new Date(startTime * 1000).toISOString()
      }
      if (endTime > 0) {
        payload.endDate = new Date(endTime * 1000).toISOString()
      }
      if (checkin.signature) {
        payload.organizer = {
          '@type': 'Organization',
          name: this.sanitizeSeoText(checkin.signature)
        }
      }
      if (checkin.banner) {
        payload.image = [checkin.banner]
      }
      return payload
    },
    // 初始化详情页默认 SEO 信息，避免接口返回前 head 为空。
    applyDefaultDetailSeo() {
      const cid = getQueryString('cid')
      // 首屏先输出稳定 SEO 信息，避免接口返回前 head 为空。
      applySeo({
        title: '签到详情 - 小小签到',
        description: '查看签到活动详情、签到时间、参与规则和动态记录。',
        robots: 'index,follow',
        canonical: this.getDetailCanonicalUrl(cid),
        ogType: 'article'
      })
    },
    // 对审核态或异常态页面设置 noindex，避免低质量状态页被收录。
    applyDetailNoIndexSeo(title, description) {
      // 审核态/异常态属于用户私域或低质量落地页，主动 noindex。
      applySeo({
        title: title || '签到详情 - 小小签到',
        description: description || '该签到页面当前不可公开展示。',
        robots: 'noindex,nofollow',
        canonical: this.getDetailCanonicalUrl(getQueryString('cid')),
        ogType: 'article'
      })
      removeJsonLd('checkin-detail-event')
      removeJsonLd('route-webpage')
    },
    // 应用详情页完整 SEO 信息，并同步注入 JSON-LD 结构化数据。
    applyDetailSeo(checkin) {
      const templateLabel = this.getTemplateLabel(checkin)
      const plainTitle = this.sanitizeSeoText((checkin && checkin.title) || '签到详情')
      const canonicalUrl = this.getDetailCanonicalUrl(checkin && checkin.cid)
      const description = this.buildDetailDescription(checkin, templateLabel)
      applySeo({
        title: `${plainTitle} - ${templateLabel} - 小小签到`,
        description,
        robots: 'index,follow',
        canonical: canonicalUrl,
        ogType: 'article',
        ogImage: checkin && (checkin.banner || checkin.banner_video_thumb || '')
      })
      // 与当前 canonical 同步更新结构化数据，避免旧活动数据残留。
      setJsonLd('checkin-detail-event', this.buildDetailJsonLd(checkin, canonicalUrl))
    },
  },
}
</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px / 75+rem;
}

.page {
  padding-bottom: calc(env(safe-area-inset-bottom) + #{rem(140)});
  // background: #fff;
  background-color: transparent;
  overflow-x: hidden;
}

.page--error {
  padding-bottom: 0;
  background: #efefef;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
}

.error-box {
  padding: rem(20) 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.error-icon {
  width: rem(120);
  height: rem(120);
}

.error-title {
  margin: 0;
  margin-top: rem(20);
  font-size: rem(32);
  font-weight: bold;
}

.error-text {
  margin: 0;
  margin-top: rem(20);
  font-size: rem(28);
  color: #333;
}

.error-removed {
  max-width: 500px;
  margin: 0 auto;
  height: 100vh;
  overflow: hidden;
  padding: rem(100) rem(30) rem(24);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}

.error-removed__icon {
  width: rem(128);
  height: rem(128);
}

.error-removed__title {
  margin: rem(34) 0 0;
  font-size: rem(36);
  line-height: 1.2;
  color: #111;
  font-weight: 600;
}

.error-removed__desc {
  margin: rem(24) 0 0;
  font-size: rem(26);
  line-height: 1.4;
  color: #9a9a9a;
  text-align: center;
}

.error-removed__meta {
  width: 100%;
  background: #f4f4f4;
  margin-top: rem(42);
  padding: rem(26) rem(24);
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: rem(20);
  row-gap: rem(12);
}

.error-removed__row {
  display: flex;
  align-items: flex-start;
}

.error-removed__row--full {
  grid-column: 1 / -1;
}

.error-removed__label {
  width: rem(128);
  flex: 0 0 auto;
  color: #666;
  font-size: rem(28);
  line-height: 1.5;
}

.error-removed__value {
  min-width: 0;
  flex: 1;
  color: #222;
  font-size: rem(28);
  line-height: 1.5;
  word-break: break-all;
}

.error-removed__value--link {
  color: #222;
}

.error-removed__actions {
  width: 100%;
  margin-top: rem(34);
  display: flex;
  gap: rem(80);
}

.error-removed__btn {
  flex: 1;
  height: rem(74);
  border: 1px solid #c4c4c4;
  border-radius: rem(12);
  background: #fff;
  color: #333;
  font-size: rem(30);
  line-height: rem(74);
  cursor: pointer;
}

.error-removed__banner-link {
  display: block;
  width: 100%;
  margin-top: 20px;
  padding-top: rem(24);
}

.error-removed__banner {
  width: 100%;
  display: block;
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.icon-24 {
  width: rem(24);
  height: rem(24);
  margin-left: rem(10);
}

.top-10 {
  margin-top: rem(10);
}

.top-20 {
  margin-top: rem(20);
}

.class-member-bar {
  position: relative;
  height: rem(96);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 rem(30);
  box-sizing: border-box;
  cursor: pointer;
}

.class-member-bar__wx-trigger {
  position: absolute;
  inset: 0;
}

.class-member-bar__left {
  display: flex;
  align-items: center;
  color: #262626;
  font-size: rem(30);
  font-weight: 700;
}

.class-member-bar__icon {
  width: rem(38);
  height: rem(38);
  border-radius: rem(8);
  margin-right: rem(12);
  background: #f6d14a;
  color: #fff;
  font-size: rem(24);
  line-height: rem(38);
  text-align: center;
  flex: 0 0 auto;
}

.class-member-bar__right {
  display: flex;
  align-items: center;
  color: #1eb6f7;
  font-size: rem(30);
}

.class-member-bar__arrow {
  width: rem(24);
  height: rem(24);
  margin-left: rem(10);
}

.meeting-requirements {
  margin-top: rem(20);
  padding: rem(20) rem(30);
  background: #fff;
}

.meeting-requirements__title {
  font-size: rem(28);
  color: #666;
  font-weight: 600;
}

.meeting-requirements__item {
  margin-top: rem(8);
  font-size: rem(26);
  color: #999;
  line-height: 1.5;
}

.meeting-detail {
  background: #fff;
}

.meeting-detail__header {
  padding: 0 rem(30);
  height: rem(94);
  line-height: rem(94);
  font-size: rem(32);
  color: #262626;
  font-weight: 700;
  border-bottom: 1px solid #ececec;
}

.meeting-detail__content {
  padding: rem(20) rem(30);
}

.meeting-detail__empty {
  padding: rem(36) rem(30);
  text-align: center;
  color: #999;
  font-size: rem(26);
}

.meeting-sheet {
  margin-top: rem(20);
  background: #fff;
}

.checkin-record-header {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid #f2f2f7;
  height: rem(90);
  font-size: rem(26);
  padding: 0 rem(30);
  justify-content: space-between;
}

.checkin-record-header-label {
  color: #999;
  font-size: rem(28);
  font-weight: 700;
  margin-right: rem(6);
}

.btn-message-second {
  color: #12b7f5;
  font-size: rem(28);
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.btn-message-second img {
  width: rem(28);
  height: rem(28);
  margin-right: rem(10);
  vertical-align: middle;
}

.meeting-sheet-head {
  display: flex;
  align-items: center;
  gap: rem(12);
  min-width: 0;
}

.meeting-sheet-tag {
  height: rem(50);
  line-height: rem(50);
  border: 1px solid #d9d9d9;
  border-radius: rem(32);
  background: #fff;
  color: #999;
  font-size: rem(26);
  padding: 0 rem(20);
  cursor: pointer;
}

.meeting-sheet-tag--active {
  border-color: #12b7f5;
  color: #12b7f5;
}

.meeting-sheet-table-wrap {
  overflow-x: auto;
  background: #fff;
  // margin: 0 rem(20);
}

.meeting-sheet-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.meeting-sheet-table th:nth-child(1),
.meeting-sheet-table td:nth-child(1) {
  width: 16%;
}

.meeting-sheet-table th:nth-child(2),
.meeting-sheet-table td:nth-child(2),
.meeting-sheet-table th:nth-child(3),
.meeting-sheet-table td:nth-child(3) {
  width: 27%;
}

.meeting-sheet-table th:nth-child(4),
.meeting-sheet-table td:nth-child(4) {
  width: 30%;
}

.meeting-sheet-table th,
.meeting-sheet-table td {
  border: 1px solid #ececec;
  padding: rem(16) rem(12);
  font-size: rem(26);
  line-height: 1.35;
  color: #262626;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.meeting-sheet-table th {
  background: #f2f2f7;
  font-weight: 700;
}

.show-sheet-tip {
  font-size: rem(26);
  color: #262626;
  text-align: center;
  padding: rem(30) 0;
  background-color: #fff;
}

.no-more-data {
  text-align: center;
  color: #999;
  font-size: rem(26);
  margin: rem(30);
}

.empty-img {
  width: rem(120);
  height: rem(120);
}

 
.meeting-sheet-footer {
  background: #fff;
  border-top: 1px solid #ececec;
}

.meeting-sheet-footer__more {
  height: rem(90);
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: #fff;
  color: #12b7f5;
  font-size: rem(28);
  text-align: center;
  cursor: pointer;
}

.meeting-sheet-footer__more img {
  width: rem(24);
  height: rem(24);
  margin-left: rem(12);
}

.meeting-sheet-footer__placeholder {
  height: rem(90);
}

.pc-ad-slot {
  width: rem(420);
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  margin-left: 375px;
  top: rem(40);
  z-index: 12;
}

.pc-ad-slot__card {
  background: #fff;
  border: 1px solid #d9d9d9;
  padding: rem(20);
}

.pc-ad-slot__qr {
  width: 100%;
  display: block;
}

.pc-ad-slot__tip {
  margin-top: rem(16);
  color: #666;
  font-size: rem(28);
  line-height: 1.5;
  text-align: center;
}

.pc-ad-slot__cta {
  margin-top: rem(16);
  display: block;
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #12b7f5;
  font-size: rem(30);
  font-weight: 700;
  text-align: center;
  line-height: rem(84);
  text-decoration: none;
}

.calendar-guide {
  height: rem(108);
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 rem(30);
  box-sizing: border-box;
  cursor: pointer;
}

.calendar-guide__left {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
}

.calendar-guide__name {
  max-width: rem(280);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: rem(30);
  color: #262626;
  margin-left: rem(20);
}

.calendar-guide__avatar {
  width: rem(68);
  height: rem(68);
  border-radius: 50%;
  object-fit: cover;
  display: block;
  flex: 0 0 auto;
}

.calendar-guide__edit {
  width: rem(30);
  height: rem(30);
  margin-left: rem(10);
  flex-shrink: 0;
}

.calendar-guide__right {
  margin-left: rem(20);
  display: flex;
  align-items: center;
  color: #12b7f5;
  font-size: rem(30);
}

.calendar-guide__arrow {
  width: rem(24);
  height: rem(24);
  margin-left: rem(10);
}

.button {
  display: block;
  width: rem(690);
  height: rem(88);
  line-height: rem(88);
  border: 0;
  padding: 0;
  text-align: center;
  margin: auto;
  font-size: rem(30);
  font-family: inherit;
  border-radius: rem(8);
  color: #fff;
  cursor: pointer;
  background-color: #12b7f5;
  -webkit-appearance: none;
  appearance: none;
}

.button--with-wx-trigger {
  position: relative;
  overflow: hidden;
}

.button-wx-trigger {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.gray {
  background-color: #e5e5ea;
  color: #999999;
}

.yellow {
  background-color: #ffcc00;
}

.light {
  background-color: #71d4f9;
  color: #e5f7fe;
}

.audit-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: rem(400);
}

.audit-img {
  width: rem(226);
  height: rem(190);
}

.sign-code {
  background-color: #fff;
  margin-bottom: rem(100);
  padding-bottom: env(safe-area-inset-bottom);

  .sign-title {
    text-align: center;
    font-size: 18px;
    padding-top: 20px;
  }

  .sign-img {
    width: 100%;
    height: auto;
    display: block;
    margin: 20px auto;
  }
}

.sign-panel {
  margin-top: rem(20);

  .wx-panel {
    position: relative;
  }

  .wx-btn {
    position: absolute;
    top: 0;
    left: rem(30);
    width: rem(690);
    height: rem(88);
  }
}

.detail-fixed-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  width: 100%;
  max-width: 500px;
  display: flex;
  align-items: center;
  gap: rem(12);
  // 回退值：先给固定底部间距，兼容不支持 max(env()) 的 WebKit。
  padding: rem(12) rem(16) calc(#{rem(12)} + #{rem(8)});
  // iOS 微信底部导航（左右箭头）收起时，safe-area 可能瞬时变小，给一个最小兜底防止按钮压进安全区。
  padding: rem(12) rem(16) calc(#{rem(12)} + max(env(safe-area-inset-bottom), #{rem(8)}));
  box-sizing: border-box;
  background: #fff;
  border-top: 1px solid #ececec;
  z-index: 30;
}

.detail-fixed-bar__side-btn {
  flex: 1;
  height: rem(88);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: rem(4);
  border: 0;
  background: transparent;
  color: #262626;
  font-size: rem(26);
  line-height: 1.2;
  text-align: center;
  cursor: pointer;
}

.detail-fixed-bar__side-btn:hover {
  font-weight: bold;
}

.detail-fixed-bar__side-icon {
  width: rem(36);
  height: rem(36);
  margin-bottom: rem(8);
}

.detail-fixed-bar__main {
  flex: 4;
  min-width: 0;
}

.detail-fixed-bar__main .sign-panel {
  margin-top: 0;
}

.detail-fixed-bar__main .button {
  width: 100%;
  margin: 0;
}

.detail-fixed-bar__main .wx-btn {
  top: 0;
  left: 0;
  width: 100%;
}

.share-guide {
  position: fixed;
  inset: 0;
  z-index: 40;
  display: flex;
  justify-content: center;
}

.share-guide__content {
  width: 100%;
  max-width: 500px;
  min-height: 100%;
  background: rgba(0, 0, 0, 0.75);
}

.share-guide__arrow {
  text-align: right;
  padding: rem(20) rem(30) 0 0;
  box-sizing: border-box;

  img {
    width: rem(160);
  }
}

.share-guide__center {
  margin-top: rem(90);
}

.share-guide__desc {
  text-align: center;
  font-size: rem(58);
  line-height: 1.45;
  color: #22bbff;
  margin-top: rem(18);
}

.share-panel,
.share-qr,
.share-asset,
.share-link {
  position: fixed;
  inset: 0;
  z-index: 50;
}

.share-panel__mask,
.share-qr__mask,
.share-asset__mask,
.share-link__mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}

.share-panel__body,
.share-qr__body,
.share-asset__body,
.share-link__body {
  position: absolute;
  left: 50%;
  width: 100%;
  max-width: 500px;
  transform: translateX(-50%);
  bottom: 0;
  background: #fff;
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: border-box;
}

.share-panel__title,
.share-qr__title {
  height: rem(104);
  line-height: rem(104);
  color: #999;
  font-size: rem(28);
  text-align: center;
}

.share-panel__grid {
  display: flex;
  flex-wrap: wrap;
  padding: 0 rem(24) rem(10);
}

.share-panel__item {
  width: 20%;
  border: 0;
  padding: 0;
  margin-bottom: rem(40);
  text-align: center;
  cursor: pointer;
  background: transparent;
  font: inherit;
  color: inherit;
  -webkit-appearance: none;
  appearance: none;
}

.share-panel__icon {
  width: rem(48);
  height: rem(48);
  display: block;
  margin: 0 auto rem(16);
}

.share-panel__text {
  color: #262626;
  font-size: rem(24);
  line-height: 1.4;
}

.share-panel__cancel {
  height: rem(100);
  line-height: rem(100);
  width: 100%;
  border: 0;
  padding: 0;
  background: #f2f2f7;
  color: #262626;
  font-size: rem(30);
  text-align: center;
  cursor: pointer;
  font-family: inherit;
  -webkit-appearance: none;
  appearance: none;
}

.share-qr__body {
  left: 50%;
  bottom: 50%;
  width: calc(100% - #{rem(80)});
  max-width: 500px;
  transform: translate(-50%, 50%);
  border-radius: rem(20);
  padding: rem(10) rem(30) rem(30);
  box-sizing: border-box;
}

.share-qr__img {
  width: rem(360);
  height: rem(360);
  display: block;
  margin: 0 auto;
}

.share-qr__desc {
  margin-top: rem(20);
  color: #999;
  font-size: rem(24);
  text-align: center;
}

.share-qr__actions {
  display: flex;
  gap: rem(16);
  margin-top: rem(24);
}

.share-qr__btn {
  flex: 1;
  height: rem(76);
  border-radius: rem(12);
  background: #12b7f5;
  color: #fff;
  font-size: rem(28);
  line-height: rem(76);
  text-align: center;
}

.share-qr__btn--light {
  background: #f2f2f7;
  color: #262626;
}

.share-asset__body,
.share-link__body {
  bottom: 50%;
  width: calc(100% - #{rem(60)});
  transform: translate(-50%, 50%);
  border-radius: rem(24);
  overflow: hidden;
  padding-bottom: 0;
}

.share-asset__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: rem(28) rem(30) rem(12);
}

.share-asset__title,
.share-link__title {
  font-size: rem(34);
  color: #262626;
  font-weight: 600;
}

.share-asset__close {
  font-size: rem(48);
  line-height: 1;
  color: #999;
  cursor: pointer;
}

.share-asset__content {
  padding: 0 rem(30);
}

.share-asset__loading,
.share-asset__empty {
  height: rem(560);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: rem(28);
  color: #999;
  background: #f7f9fc;
  border-radius: rem(20);
}

.share-asset__image {
  width: 100%;
  display: block;
  border-radius: rem(20);
  background: #f7f9fc;
}

.share-asset__footer {
  padding: rem(24) rem(30) rem(30);
}

.share-asset__tip,
.share-link__desc {
  font-size: rem(24);
  line-height: 1.6;
  color: #999;
}

.share-asset__btn,
.share-link__btn {
  height: rem(80);
  line-height: rem(80);
  text-align: center;
  border-radius: rem(12);
  background: #12b7f5;
  color: #fff;
  font-size: rem(28);
}

.share-asset__btn {
  margin-top: rem(20);
}

.share-link__body {
  padding: rem(34) rem(30) rem(30);
}

.share-link__value,
.share-path__value,
.share-path__code {
  margin-top: rem(12);
  padding: rem(20) rem(24);
  border-radius: rem(12);
  background: #f3f3f3;
  border: 1px solid #e2e2e2;
  color: #999;
  font-size: rem(28);
  line-height: 1.35;
  word-break: break-all;
}

.share-link__actions {
  display: flex;
  gap: rem(16);
  margin-top: rem(24);
}

.share-link__btn {
  flex: 1;
}

.share-link__btn--light {
  background: #f2f2f7;
  color: #262626;
}

.share-path__tabs {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
  padding: rem(40) rem(20) 0;
  background: #fff;
}

.share-path__tab {
  flex: 1;
  height: rem(88);
  line-height: rem(88);
  border: 0;
  padding: 0;
  background: transparent;
  text-align: center;
  color: #999;
  font-family: inherit;
  font-size: rem(28);
  position: relative;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.share-path__tab--active {
  color: #12b7f5;
  font-weight: 600;
}

.share-path__tab--active::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  width: rem(120);
  height: rem(4);
  background: #12b7f5;
  transform: translateX(-50%);
  border-radius: rem(4);
}

.share-path__content {
  padding: rem(18) rem(30) rem(40);
  background: #fff;
}

.share-path__item+.share-path__item {
  margin-top: rem(30);
}

.share-path__label {
  font-size: rem(28);
  color: #333;
  font-weight: 600;
}

.share-path__row {
  margin-top: rem(12);
  position: relative;
}

.share-path__row .share-path__value {
  margin-top: 0;
  padding-right: rem(96);
  word-break: break-all;
}

.share-path__copy {
  position: absolute;
  right: rem(20);
  top: 50%;
  transform: translateY(-50%);
  height: rem(44);
  line-height: rem(44);
  border: 0;
  padding: 0;
  background: transparent;
  color: #12b7f5;
  font-family: inherit;
  font-size: rem(28);
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.share-link__body--path {
  width: calc(100% - #{rem(120)});
  max-width: 420px;
  border-radius: rem(12);
  overflow: hidden;
  padding: 0;
  background: #f5f5f7;
}

.share-path__close {
  position: absolute;
  right: rem(14);
  top: rem(18);
  width: rem(32);
  height: rem(32);
  border: 0;
  padding: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  -webkit-appearance: none;
  appearance: none;
}

.share-path__close img {
  width: 100%;
  height: 100%;
  display: block;
}

.share-path__tip {
  margin-top: rem(12);
  font-size: rem(24);
  line-height: 1.45;
  color: #999;
}

.share-path__tip-link {
  color: #12b7f5;
}

.share-path__code {
  white-space: pre-wrap;
  padding-right: rem(28);
}

.share-path__actions {
  margin-top: rem(24);
}

.share-path__copy-btn {
  height: rem(80);
  line-height: rem(80);
  width: 100%;
  border: 0;
  padding: 0;
  text-align: center;
  border-radius: rem(12);
  background: #12b7f5;
  color: #fff;
  font-family: inherit;
  font-size: rem(28);
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

@media screen and (min-width: 501px) {
  .page {
    padding-bottom: calc(env(safe-area-inset-bottom) + #{rem(120)});
  }

  .content {
    max-width: 100%;
  }

  .sign-code {
    margin-bottom: 0;
    padding: 0 0 rem(120);

    .sign-img {
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
    }
  }
  .button {
    width: calc(100% - #{rem(60)});
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/detail.vue